<span class="header">
  <h1 mat-dialog-title>{{"popup.notice" | translate}}</h1>
  <img class="cancel" src="assets/img/icons/delete2.svg" (click)="discard()">
</span>
<div class="message">
  {{"popup.performance" | translate}}
  <a href="https://www.google.com/intl/en/chrome/">Google Chrome</a>
  {{"popup.or" | translate}}
  <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a>
</div>
